<template>
  <div class="index">
    <div class="title-banner-boxBG">
      <img class="banner-r" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/banner-r.png" alt="">
    </div>
    <div class="title-banner-box">
      <div class="title-banner-t1">
        <span>炯耀</span>
      </div>
      <div class="title-banner-t2">
        <span>创新引领未来 诚信铸就品质</span>
        <div class="title-banner-t2line"></div>
      </div>
      <div class="title-banner-t3">
        <span>Innovation leads the future, integrity creates quality</span>
      </div>
      <div class="banner-btn-box">
        <img class="banner-btn" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/index-banner-upper.png" alt="">
        <img class="banner-btn" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/index-banner-next.png" alt="">
        <div @click="gowe" class="banner-btn2">了解更多</div>
      </div>
      <img class="banner-r-t" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/banner-t1.png" alt="">
    </div>
<!--    <div id="industry" class="industry-box">
        <div class="industry-box-title">行业</div>
        <div class="industry-box-title2">通过战略咨询、数字化和创新，为全球客户提供战略级前瞻规划</div>
        <div class="industry-box-title2">咨询、研发、产品和解决方案，助力客户应对挑战，实现客户新</div>
        <div class="industry-box-title2">价值！</div>
    </div>
    <div class="industry-box-go-box">
      <div @click="goretail" class="industry-box-go" >
        <img  class="industry-box-icon industry1Show1" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/business-r.png" alt="">
        <img  class="industry-box-icon industry1Show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/business.png" alt="">
        <span>零售行业</span>
      </div>
      <div @click="goeducation" class="industry-box-go">
        <img  class="industry-box-icon industry1Show1" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/education-r.png" alt="">
        <img class="industry-box-icon industry1Show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/education.png" alt="">
        <span>教育行业</span>
      </div>
    </div>-->
    <div id="product" class="product-box">
        <div class="product-box-t1">知新SCRM</div>
<!--        <div class="product-box-t2">提供端到端的解决方案和行业内的最佳实践，助力企业打造竞争优势，驱动业务快速发展，实现卓越绩效。</div>-->
        <div class="product-swiper">
         <swiper ref="mySwiper" :options="swiperOptions">
           <swiper-slide  >
             <div class="scrmCont">
               <img class="scrmImg" src="@/assets/img/scrmT1.png" alt="">
               <div class="scrmTextBox pl180">
                 <div class="scrmTitle">线索管理</div>
                 <div class="scrmText mt10">全渠道智能获客，精准ROI分析</div>
                 <div class="scrmText mt38">* 线索接入：全渠道接入，无需手动操作</div>
                 <div class="scrmText mt10">* 多场景获客：营销素材、渠道活码、社交互动等</div>
                 <div class="scrmText mt10">* 渠道ROI分析：智能计算渠道ROI，制定精准投放策略</div>
               </div>
             </div>
           </swiper-slide>
           <swiper-slide  >
             <div class="scrmCont">
               <img class="scrmImg" src="@/assets/img/scrmT2.png" alt="">
               <div class="scrmTextBox pl180">
                 <div class="scrmTitle">客户管理</div>
                 <div class="scrmText mt10">全生命周期客户管理，全面赋能销售</div>
                 <div class="scrmText mt38">* 客户资料全方位统一管理，标签画像、旅程、行为轨迹动态实时更新</div>
                 <div class="scrmText mt10">* 企微好友及社交关系沉淀，沟通记录、历史信息全部保留，随时查看</div>
                 <div class="scrmText mt10">* 客户流失，系统自动提醒，客户信息随时掌握</div>
               </div>
             </div>
           </swiper-slide>
           <swiper-slide  >
             <div class="scrmCont">
               <img class="scrmImg" src="@/assets/img/scrmT3.png" alt="">
               <div class="scrmTextBox pl180">
                 <div class="scrmTitle">营销管理</div>
                 <div class="scrmText mt10">多渠道、全场景智能获客</div>
                 <div class="scrmText mt38">* 获客助手：缩短获客路径，更快、更方便触达客户</div>
                 <div class="scrmText mt10">* 智能表单：丰富的表单模板，灵活定制化表单，满足全场景获客</div>
                 <div class="scrmText mt10">* 营销资料库：管理营销素材，可对营销素材打标签，智能计算营销分</div>
                 <div class="scrmText mt10">* 活码：支持多种活码，比如：群活码、渠道活码、门店活码、一客一码，多场景获客</div>

               </div>
             </div>
           </swiper-slide>
           <swiper-slide  >
             <div class="scrmCont">
               <img class="scrmImg" src="@/assets/img/scrmT4.png" alt="">
               <div class="scrmTextBox pl180">
                 <div class="scrmTitle">销售管理</div>
                 <div class="scrmText mt10">全流程自动化销售管理，提高销售效率</div>
                 <div class="scrmText mt38">* 销售机会阶段化管理，灵活、方便进行销售机会跟进</div>
                 <div class="scrmText mt10">* 沟通记录随时掌握，便于管理层及时干预，提高转化率</div>
                 <div class="scrmText mt10">* 实时、多维度业绩分析，实时查看进度情况</div>
               </div>
             </div>
           </swiper-slide>
           <swiper-slide  >
             <div class="scrmCont">
               <img class="scrmImg" src="@/assets/img/scrmT5.png" alt="">
               <div class="scrmTextBox pl180">
                 <div class="scrmTitle">活动管理</div>
                 <div class="scrmText mt10">全渠道精准营销</div>
                 <div class="scrmText mt38">* 活动日历可视化：通过活动日历，一目了然查看各种活动</div>
                 <div class="scrmText mt10">* 智能活动路径：可以对活动灵活配置营销动作、条件判断和流程控制，自动执行</div>
                 <div class="scrmText mt10">* 智能分析活动ROI，以便调整营销活动策略</div>
               </div>
             </div>
           </swiper-slide>
          </swiper>
          <div class="swiper-button-next"  @click="next(1)" slot="button-next"></div>
          <div class="swiper-button-prev"  @click="prev(1)" slot="button-prev"></div>
        </div>
    </div>
    <div id="service" class="service-box">
      <div class="service-box-t1">核心服务</div>
      <div class="service-box-t2">通过洞察与咨询、数字化与创新，为全球客户提供战略级前瞻规划咨询、研发和产品，助力客户应对挑战，实现客户新价值。</div>
      <div class="service-c1box">
        <div class="InsightL">
          <div class="spotTop"><div class="spotN"></div></div>
          <img class="InsightImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/Insight.png" alt="">
        </div>
        <div class="InsightR">
          <div class="InsightR-title">洞察</div>
          <div class="InsightR-title2">有深度的内容，有价值的思考</div>
          <div class="InsightR-title3">我们拥有各领域研究型专家、数字时代的开拓者</div>
          <div class="InsightR-title3">和创新者，聚焦前沿科技潮流，洞悉行业发展趋势，</div>
          <div class="InsightR-title3">为企业赋予新价值。</div>
          <div class="InsightR-Btn">
            <img class="go-Inside-btn" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/arrow.png" alt="">
          </div>
        </div>
      </div>
      <div class="service-c2box">
        <div class="consultingL">
          <div class="zd1"></div>
          <div class="zd2"></div>
          <div class="InsightR-title">战略与咨询</div>
          <div class="InsightR-title2">拥抱变化，赢在未来</div>
          <div class="InsightR-title3">我们拥有战略和行业专家、管理咨询顾问、高科技专业人才、</div>
          <div class="InsightR-title3">数字化体验专家、数据科学家，助力企业增强竞争力，提高敏</div>
          <div class="InsightR-title3">捷性，快速应对行业变化，赋能转型。</div>
          <div class="InsightR-Btn">
            <img class="go-Inside-btn" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/arrow.png" alt="">
          </div>
        </div>
        <div class="consultingR">
            <img class="consult" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/consult.png" alt="">
        </div>
      </div>
      <div class="service-c3box">
        <div class="digitizationL">
          <div class="zb1"></div>
          <div class="zb2"></div>
          <img class="digitizationImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/digitization.png" alt="">
        </div>
        <div class="digitizationR">
          <div class="InsightR-title">数字化</div>
          <div class="InsightR-title2">流程实现全数字化，数据推动业务发展</div>
          <div class="InsightR-title3">我们拥有数字化体验专家、业务专家、数据专家，助力客户提</div>
          <div class="InsightR-title3">高数字化认知，打造数字化能力，提供全渠道数字化营销解决</div>
          <div class="InsightR-title3">方案和数字化转型服务。</div>
          <div class="InsightR-Btn">
            <img class="go-Inside-btn" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/arrow.png" alt="">
          </div>
        </div>
      </div>
      <div class="service-c4box">
          <div class="innovateL" style="padding-left: 112px;">
            <div class="zb1"></div>
            <div class="zb2"></div>
            <div class="InsightR-title">创新</div>
            <div class="InsightR-title2">创新引领未来，赋能企业转型</div>
            <div class="InsightR-title3">运用创新认知和数字化技术，助力企业解决业务痛点，提升企</div>
            <div class="InsightR-title3">业运营能力。重塑核心业务与拓展新业务模式，重新思考定位</div>
            <div class="InsightR-title3">企业服务形式，为商业模式和业务发展注入活力，调动企业积</div>
            <div class="InsightR-title3">极性，从而开辟企业数字化转型的新途径，实现企业转型和业</div>
            <div class="InsightR-title3">务发展。</div>
            <div class="InsightR-Btn">
              <img class="go-Inside-btn" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/arrow.png" alt="">
            </div>
          </div>
          <div class="innovateR">
            <img class="innovateLImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/innovate.png" alt="">
          </div>
      </div>
      <div class="service-c5box">
        <div class="jwL">
          <div class="zb1"></div>
          <div class="zb2"></div>
          <div class="ending"><div class="endingN"></div></div>
        </div>
      </div>
    </div>
    <div id="technical" class="technical-box">
      <div class="technical-t1">技术能力</div>
      <div class="technical-t2">以创新技术为根，以知心服务为本</div>
      <div class="technical-cont-box">
        <div class="technical-cont">
          <div class="technical-cont-t">
            <img class="technical-cont-tImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/UIICON.png" alt="">
          </div>
          <div class="technical-cont-t1">数字化互动</div>
          <div class="technical-cont-t2">真正以用户为中心的全渠道体验设计、开发、构建和发布。</div>
        </div>
        <img class="technical-box-and" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/and.png" alt="">
        <div class="technical-cont">
          <div class="technical-cont-t">
            <img class="technical-cont-tImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/framework.png" alt="">
          </div>
          <div class="technical-cont-t1">技术咨询和架构</div>
          <div class="technical-cont-t2">IT规划、架构设计、云计算、微服务等。</div>
          <div class="technical-cont-t2"></div>
        </div>
        <img class="technical-box-and" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/and.png" alt="">
        <div class="technical-cont">
          <div class="technical-cont-t">
            <img class="technical-cont-tImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/appIcon.png" alt="">
          </div>
          <div class="technical-cont-t1">应用开发</div>
          <div class="technical-cont-t2">构建完善应用系统（B/S应用、微信生态应用、移动应用和智能应用），运用数字化技术推动企业战略实施。</div>
        </div>
        <img class="technical-box-and" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/and.png" alt="">
        <div class="technical-cont">
          <div class="technical-cont-t">
            <img class="technical-cont-tImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/analysis.png" alt="">
          </div>
          <div class="technical-cont-t1">数据科学与分析</div>
          <div class="technical-cont-t2">借助全球领先的技术，如：数据可视化与分析、算法、人工智能、机器学习、深度学习等），打造智能企业。</div>
        </div>
      </div>
    </div>
    <div id="cooperation" class="cooperation-box">
      <div class="cooperation-t1">合作案例</div>
      <div class="cooperation-t2">与客户高效合作，助其实现新价值</div>
      <div class="cooperation-swiper">
        <swiper  ref="cooperationSwiper" :options="swiperOptions2">
          <swiper-slide>
            <div class="cooperation-slide">
              <img class="industry-box-icon" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/index-cooperation-t1.png" alt="">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="cooperation-slide">
              <img class="industry-box-icon" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/index-cooperation-t2.png" alt="">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="cooperation-slide">
              <img class="industry-box-icon" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/index-cooperation-t3.png" alt="">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="cooperation-slide">
              <img class="industry-box-icon" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/index-cooperation-t4.png" alt="">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="cooperation-slide">
              <img class="industry-box-icon" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/index-cooperation-t5.png" alt="">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="cooperation-slide">
              <img class="industry-box-icon" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/index-cooperation-t6.png" alt="">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="cooperation-slide">
              <img class="industry-box-icon" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/index-cooperation-t7.png" alt="">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="cooperation-slide">
              <img class="industry-box-icon" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/index-cooperation-t8.png" alt="">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="cooperation-slide">
              <img class="industry-box-icon" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/index-cooperation-t9.png" alt="">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="cooperation-slide">
              <img class="industry-box-icon" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/index-cooperation-t10.png" alt="">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="cooperation-slide">
              <img class="industry-box-icon" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/index-cooperation-t11.png" alt="">
            </div>
          </swiper-slide>
        </swiper>
        <div class="cooperation-swiper-btnbox">
          <img class="cooperation-swiper-btn cooperation-next" @click="next(2)" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/cooperation-next.png" alt="">
          <img class="cooperation-swiper-btn cooperation-prve" @click="prev(2)" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/cooperation-prve.png" alt="">
        </div>
      </div>
    </div>
    <div id="partner" class="partner-box">
        <div class="partner-t1">合作伙伴</div>
        <div class="partner-t2">携手前进，共创辉煌</div>
<!--        <div class="partner-swiper">
          <swiper class="swiper-no-swiping" ref="partneSwiper" :options="swiperOptions3">
            <swiper-slide>
              <div class="partne-slide partne-slide10"></div>
            </swiper-slide>
            <swiper-slide>
              <div class="partne-slide partne-slide11"></div>
            </swiper-slide>
            <swiper-slide>
              <div class="partne-slide partne-slide12"></div>
            </swiper-slide>
            <swiper-slide>
              <div class="partne-slide partne-slide1"></div>
            </swiper-slide>
            <swiper-slide >
              <div class="partne-slide partne-slide2"></div>
            </swiper-slide>
            <swiper-slide>
              <div class="partne-slide partne-slide3"></div>
            </swiper-slide>
            <swiper-slide>
              <div class="partne-slide partne-slide4"></div>
            </swiper-slide>
            <swiper-slide >
              <div class="partne-slide partne-slide5"></div>
            </swiper-slide>
            <swiper-slide >
              <div class="partne-slide partne-slide9">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="partne-slide partne-slide6"></div>
            </swiper-slide>
            <swiper-slide >
              <div class="partne-slide partne-slide7"></div>
            </swiper-slide>
            <swiper-slide >
              <div class="partne-slide partne-slide8"></div>
            </swiper-slide>

          </swiper>
          <img class="art-prev" @click="prev(3)" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/art-prev.png" alt="">
          <img class="art-next" @click="next(3)" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/art-next.png" alt="">
        </div>-->
<!--   logo展开   -->
      <div class="logo-boxbg">
        <div class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/zhuoyue-a.png" alt="">
          </div>
        </div>

        <div class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/qichen.png" alt="">
          </div>
        </div>
        <div class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/pufa-a.png" alt="">
          </div>
        </div>
        <div class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/qiqu-a.png" alt="">
          </div>
        </div>
        <div class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/qiaowen-a.png" alt="">
          </div>
        </div>
        <div class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/uxsino-a.png" alt="">
          </div>
        </div>
        <div class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg" style="width: 50px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/Starbucks-a.png" alt="">
          </div>
        </div>
        <div class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/hershey-a.png" alt="">
          </div>
        </div>
        <div class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg" style="width: 50px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/hit-off.png" alt="">
          </div>
        </div>
        <div class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/GrowingIO.png" alt="">
          </div>
        </div>
        <div class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg" style="width: 120px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/tangchao-a.png" alt="">
          </div>
        </div>
        <div class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg" style="width: 100px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/ld.png" alt="">
          </div>
        </div>
        <div class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg" style="width: 80px;height: 80px;" src="../assets/img/cooperation-logo3.png" alt="">
          </div>
        </div>
        <div class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 80px;height: 80px;" src="../assets/img/cooperation-logo1.png" alt="">
          </div>
        </div>
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 80px;height: 80px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/zhihang.png" alt="">
          </div>
        </div>
      </div>
      <div class="logo-boxbg">
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 80px;height: 80px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/XYJY.png" alt="">
          </div>
        </div>
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 100px" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/TY.png" alt="">
          </div>
        </div>
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 70px" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/qia.png" alt="">
          </div>
        </div>
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 100px" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/XYX.png" alt="">
          </div>
        </div>
        <div class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 150px" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/XINGHUI.png" alt="">
          </div>
        </div>

      </div>
      <div class="logo-boxbg">
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 120px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/VERY.png" alt="">
          </div>
        </div>
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 100px" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/MIYA.png" alt="">
          </div>
        </div>
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 100px" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/XIAOWU.png" alt="">
          </div>
        </div>
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 100px" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/ZQYS.png" alt="">
          </div>
        </div>
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 100px" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/QTYS.png" alt="">
          </div>
        </div>


      </div>
      <div class="logo-boxbg">
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 80px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/JWM.png" alt="">
          </div>
        </div>
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 100px" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/ZXPHG.png" alt="">
          </div>
        </div>
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 100px" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/FHJQR.png" alt="">
          </div>
        </div>
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 80px" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/YATKD.png" alt="">
          </div>
        </div>
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 80px" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/ZZ.png" alt="">
          </div>
        </div>


      </div>
      <div class="logo-boxbg">
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 80px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/SF.png" alt="">
          </div>
        </div>
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 80px" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/YZ.png" alt="">
          </div>
        </div>
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 100px" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/Jiliding.png" alt="">
          </div>
        </div>
        <div  class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 80px" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/box.png" alt="">
          </div>
        </div>
        <div class="logo-box">
          <div class="logo-boxImgBG">
            <img class="logo-boxImg"  style="width: 80px" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c29bebbfb6a0e438e746e05ffd463e9.png" alt="">
          </div>
        </div>


      </div>
    </div>
    <!--  锚点  -->
    <div class="jump-box" :style="isscrollTop?'right: 100px;':'right: -100px;'">
        <span class="jump" title="顶部" style="top: -15px;"  @click="scrollToAnchor('#')"><div class="jumpN"></div><div class="jumpNTips">顶部</div></span>
<!--        <a class="jump" title="行业" style="top: -10px;" href="#industry"><div class="jumpN"></div><div class="jumpNTips">行业</div></a>-->
        <span class="jump" title="知新SCRM" style="top: -5px;" @click="scrollToAnchor('#product')"><div class="jumpN"></div><div style="left: -130px;" class="jumpNTips">知新SCRM</div></span>
        <span class="jump" title="核心服务" style="bottom: -5px" @click="scrollToAnchor('#service')"><div  class="jumpN"></div><div style="left: -88px;" class="jumpNTips">核心服务</div></span>
        <span class="jump" title="技术能力" style="bottom: -10px" @click="scrollToAnchor('#technical')"><div class="jumpN"></div><div style="left: -88px;" class="jumpNTips">技术能力</div></span>
        <span class="jump" title="合作案例" style="bottom: -15px" @click="scrollToAnchor('#cooperation')"><div class="jumpN"></div><div style="left: -88px;" class="jumpNTips">合作案例</div></span>
    </div>
  </div>

</template>

<script>

export default {
  name: "index",
  data:vm=>{
    return{
      isscrollTop:false,
      industry1Show:false,
      industry2Show:false,
      index:0,
      hoverpartneIndex:-1,
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        slidesPerView: 1,
        spaceBetween: 30,
        centeredSlides: true,
        observer: true,
        observeParents: true,
        loop: true,
        on:{
          slideNextTransitionStart: function (e) {
            // console.log(22223,e.loopedSlides);
            vm.index = e.activeIndex - 4
            // if(vm.index>5){
            //   vm.index = 1
            // }
          },
          slidePrevTransitionStart: function () {
            vm.index--
            if(vm.index<0){
              vm.index = 5
            }
          },
        }
      },
      swiperOptions2:{
        pagination: {
          el: '.cooperation-swiper'
        },
        navigation: {
          nextEl: '.cooperation-next',
          prevEl: '.cooperation-prve',
        },
        slidesPerView: 3,
        spaceBetween: 0,
        centeredSlides: true,
        observer: true,
        observeParents: true,
        loop: true,
        on:{
          click: function(e){
            // var reg = /(?<=(src="))[^"]*?(?=")/ig;
            console.log(e.clickedSlide.outerHTML);
            var allSrc = e.clickedSlide.outerHTML;
            if(allSrc.indexOf('t1') != -1){
              vm.$router.push('/cooperation?num=0')
            }
            if(allSrc.indexOf('t2') != -1){
              vm.$router.push('/cooperation?num=1')
            }
            if(allSrc.indexOf('t3') != -1){
              vm.$router.push('/cooperation?num=9')
            }
            if(allSrc.indexOf('t4') != -1){
              vm.$router.push('/cooperation?num=2')
            }
            if(allSrc.indexOf('t5') != -1){
              vm.$router.push('/cooperation?num=8')
            }
            if(allSrc.indexOf('t6') != -1){
              vm.$router.push('/cooperation?num=3')
            }
            if(allSrc.indexOf('t7') != -1){
              vm.$router.push('/cooperation?num=7')
            }
            if(allSrc.indexOf('t8') != -1){
              vm.$router.push('/cooperation?num=4')
            }
            if(allSrc.indexOf('t9') != -1){
              vm.$router.push('/cooperation?num=5')
            }
            if(allSrc.indexOf('t10') != -1){
              vm.$router.push('/cooperation?num=10')
            }
            if(allSrc.indexOf('t11') != -1){
              vm.$router.push('/cooperation?num=6')
            }
          },
        },
      },
      swiperOptions3:{
        navigation: {
          nextEl: '.art-next',
          prevEl: '.art-prev',
        },
        slidesPerView: 5,
        spaceBetween: 0,
        centeredSlides: true,
        observer: true,
        observeParents: true,
        loop:true,
        on:{
          slideNextTransitionStart: function () {
            // console.log(vm.index);
          },
          slidePrevTransitionStart: function () {
            // console.log(333);
          },

        }
      },
    }
  },
computed: {
  swiper() {
    return this.$refs.mySwiper.$swiper
  },
  swiper2() {
    return this.$refs.cooperationSwiper.$swiper
  },
  swiper3() {
    return this.$refs.partneSwiper.$swiper
  },
},
methods:{
  scrollToAnchor(id) {
    if(id == '#'){
      window.scrollTo(0, 0);
    }else {
      document.querySelector(id).scrollIntoView(true);
    }
  },
  gowe(){
    this.$router.push('/we')
  },
  goretail(){
    this.$router.push('/retail')
  },
  goeducation(){
    // this.$router.push('/education')
    window.location.href = 'https://www.zhixinguo8.com/#/'
  },
  // 保存滚动值，这是兼容的写法
  handleScroll () {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    if(scrollTop>500){
      this.isscrollTop = true
    }else {
      this.isscrollTop = false
    }
  },
  hover(type){
    if(type == 1){
      this.industry1Show = true
    }else {
      this.industry2Show = true
    }
  },
  hoverout(type){
    if(type == 1){
      this.industry1Show = false
    }else {
      this.industry2Show = false
    }
  },
  prev(type) {
    if(type == 1){
      this.swiper.slidePrev();
    }else if(type == 2){
      this.swiper2.slidePrev();
    }else if(type == 3){
      this.swiper3.slidePrev();
    }
  },
  next(type) {
    if(type == 1){
      this.swiper.slideNext();
    }else if(type == 2){
      this.swiper2.slideNext();
    }else if(type == 3){
      this.swiper3.slideNext();
    }
  },
  ccc(){
    console.log(22222);
  }
},
mounted() {
  // this.swiper.slideTo(3, 1000, false)
  window.addEventListener('scroll', this.handleScroll, true)
  console.log("%c所有的结尾都已经写好，\n所有的泪水都已经启程。\n却突然忘记那是一个怎样的开始，\n在那个古老的不在回来的夏日。\n\n","color:#558058");
  if(this.$route.query.st == 1){
    this.scrollToAnchor('#service')
  }
  if(this.$route.query.st == 2){
    this.scrollToAnchor('#product')
  }
}
};
</script>

<style lang="less" scoped>
.index{
  position: relative;
  z-index: 1;
  padding-top: 200px;
}
.title-banner-boxBG{
  position: absolute;
  left: 0;
  top: -59px;
  background: rgba(248,248,248,1);
  width: 100%;
  height: 690px;
  .banner-r{
    width: 640px;
    position: absolute;
    right: 0;
    top: 0;
  }
}
.title-banner-box{
  width: 1200px;
  position: relative;
  margin: 0px auto 0 auto;
  .title-banner-t1{
    font-size:39px;
    font-weight:400;
    margin-bottom: 25px;
  }
  .title-banner-t2{
    font-size:43px;
    margin-bottom: 27px;
    font-weight:bold;
    position: relative;
    display: inline-block;
    .title-banner-t2line{
      width:209px;
      height:10px;
      background:rgba(220,6,22,1);
      position: absolute;
      bottom: 2px;
      right: 23px;
      z-index: -1;
    }
  }
  .title-banner-t3{
    font-size:20px;
    font-weight:400;
  }
  .banner-btn-box{
    margin-top: 155px;
    display: flex;
    align-items: center;
    .banner-btn{
      width: 36px;
      height: 36px;
      margin-right: 16px;
      cursor: pointer;
    }
    .banner-btn2{
      width:115px;
      height:37px;
      background:rgba(220,6,22,1);
      box-shadow:1px 1px 13px 0px rgba(220,6,22,0.1);
      border-radius:19px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size:16px;
      color:rgba(255,255,255,1);
      cursor: pointer;
      transition: all .3s linear;
    }
    .banner-btn2:hover{
      box-shadow:1px 1px 6px 3px rgba(220,6,22,.5);
    }
  }
  .banner-r-t{
    width: 880px;
    position: absolute;
    right: -190px;
    bottom: -40px;
  }
}
.industry-box{
  margin-top: 135px;
  .industry-box-title{
    text-align: center;
    font-size:40px;
    font-weight:800;
    color:rgba(11,11,11,1);
    margin-bottom: 37px;
  }
  .industry-box-title2{
    font-size:20px;
    font-weight:400;
    color: #687789;
    text-align: center;
  }
}
.industry-box-go-box{
  width: 1200px;
  margin: 110px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .industry-box-go{
    width:578px;
    height:178px;
    background:rgba(255,255,255,1);
    border:1px solid rgba(211,211,211,1);
    border-radius:3px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-weight:bold;
    font-size:26px;
    transition: all .2s linear;
    .industry-box-icon{
      width: 53px;
      margin-right: 35px;
    }
  }
  .industry-box-go:hover{
    background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/tabbg.png");
    -webkit-background-size: 100% 100%;
    background-size: 100% 100%;
    box-shadow: 0 0 21px 2px rgba(220,6,22,1);
    border: none;
    color: #fff !important;
  }
  .industry-box-go:hover .industry1Show1{
    display: none;
  }
  .industry1Show2{
    display: none;
  }
  .industry-box-go:hover .industry1Show2{
    display: inline-block;
  }
}
.product-box{
  margin-top: 137px;
  width: 100%;
  height:500px;
  background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/productBG.png") no-repeat;
  -webkit-background-size: 100% 100%;
  background-size: 100% 100%;
  box-sizing: content-box;
  padding-top: 24px;
  .product-box-t1{
    font-size:40px;
    font-weight:800;
    color: #fff;
    text-align: center;
  }
  .product-box-t2{
    margin-top: 16px;
    font-size:20px;
    color: #fff;
    text-align: center;
  }
  .product-swiper{
    width: 1200px;
    margin:10px auto 0 auto;
    position: relative;
    .swiper-button-next{
      color: #fff;
      position: absolute;
      right: -40px;
    }
    .swiper-button-prev{
      color: #fff;
      position: absolute;
      left: -40px;
    }
    .swiper-slide {
      position: relative;
      justify-content: center;
      text-align: center;
      width:223px;
      height:391px;
      font-size: 18px;
      /*background: rgba(255,255,255,.9);*/
      /* Center slide text vertically */
      display: flex;
      align-items: center;
      transition: all .3s linear;
      transform: scale(0.8);
      .product-swiper-cbg{
        /*cursor:pointer;*/
        width: 134px;
        height: 234px;
        /*background: #FAEAEB;*/
        border: 1px solid #B10515;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        font-weight: bold;
        color: #B00616;
        .product-icon{
          width: 60px;
          margin-bottom: 16px;
        }
      }
      .product-nicon{
        position: absolute;
        right: 18px;
        bottom: 20px;
        width: 34px;
      }
    }
    .product-iconshow{
      display: block;
    }
    .product-iconshow2{
      display: none;
    }
    /deep/ .swiper-slide-active{
      .product-swiper-cbg{
        background: none;
        border: 1px solid #fff;
        color: #fff;
      }
      .product-iconshow{
        display: none !important;
      }
      .product-iconshow2{
        display: block !important;
      }
    }
  }
}
/deep/ .swiper-slide-active,.swiper-slide-duplicate-active{
  transform: scale(1) !important;
}
/* 弯弯曲曲 */
.InsightR-title{
  font-size:28px;
  color: #0B0B0B;
  font-weight:800;
}
.InsightR-title2{
  margin-top: 40px;
  margin-bottom: 20px;
  font-size:24px;
  color: #0B0B0B;
}
.InsightR-title3{
  font-size:16px;
  color: #0B0B0B;
}
.InsightR-Btn{
  margin-top: 30px;
  width: 54px;
  height: 54px;
  -webkit-border-radius: 100%;
  -moz-border-radius: 100%;
  border-radius: 100%;
  background: #DC0616;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  .go-Inside-btn{
    cursor: pointer;
    width: 22px;
  }

}
.InsightR-Btn:hover{
  box-shadow:1px 1px 6px 3px rgba(220,6,22,.5);
}
.service-box{
  margin-top: 90px;
  .service-box-t1{
    font-size:40px;
    font-weight:800;
    text-align: center;
    color: #0B0B0B;
  }
  .service-box-t2{
    margin-top: 16px;
    margin-bottom: 90px;
    font-size:20px;
    text-align: center;
    color:#687789;
  }
  .service-c1box{
    display: flex;
    position: relative;
    width: 1200px;
    margin: 0 auto;
    .InsightL{
      width: 50%;
      height: 600px;
      border-bottom-right-radius: 80px;
      border-right: 2px dashed #BFBFBF;
      border-bottom: 2px dashed #BFBFBF;
      position: relative;
      .spotTop{
        position: absolute;
        right: -16px;
        top: -16px;
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        background:rgba(220,6,22,.17);
        border-radius:50%;
        .spotN{
          width:13px;
          height:13px;
          background:rgba(220,6,22,1);
          border-radius:50%;
        }
      }
    }
    .InsightR{
      padding-top: 116px;
      padding-left: 77px;

    }
  }
  .service-c2box{
    display: flex;
    position: relative;
    width: 1200px;
    margin: 0 auto;
    .consultingL{
      padding-top: 200px;
      padding-left: 134px;
      width: 50%;
      height: 600px;
      border-top-left-radius: 80px;
      border-bottom-left-radius: 80px;
      border-top: 2px dashed #BFBFBF;
      border-left: 2px dashed #BFBFBF;
      border-bottom: 2px dashed #BFBFBF;
      position: relative;
      top: -3px;
      background: #fff;
      z-index: 1;
      .zd1{
        position: absolute;
        left: -1px;
        top: -4px;
        z-index: 2;
        width: 61px;
        height: 5px;
        background: #fff;
      }
      .zd2{
        position: absolute;
        right: -1px;
        top: -2px;
        z-index: 2;
        width:124px;
        height: 5px;
        background: #fff;
      }
    }
    .consultingR{
      padding-top: 120px;
      padding-left: 67px;
      .consult{

      }
    }
  }
  .service-c3box{
    display: flex;
    position: relative;
    width: 1200px;
    margin: 0 auto;
    .digitizationL{
      width: 50%;
      height: 600px;
      border-bottom-right-radius: 80px;
      border-top-right-radius: 80px;
      border-top: 2px dashed #BFBFBF;
      border-right: 2px dashed #BFBFBF;
      border-bottom: 2px dashed #BFBFBF;
      position: relative;
      top: -8px;
      .zb1{
        position: absolute;
        left: -1px;
        top: -3px;
        width: 53px;
        height: 3px;
        background: #fff;
        z-index: 3;
      }
      .zb2{
        position: absolute;
        right: -66px;
        top: 1px;
        width: 118px;
        height: 3px;
        background: #fff;
        z-index: 3;
      }
      .digitizationImg{
        width: 519px;
        margin-top: 60px;
      }
    }
    .digitizationR{
      padding-top: 116px;
      padding-left: 67px;
    }
  }
  .service-c4box{
    display: flex;
    position: relative;
    z-index: 2;
    background: #fff;
    width: 1200px;
    margin: 0 auto;
    .innovateL{
      width: 50%;
      height: 600px;
      border-bottom-left-radius: 80px;
      border-top-left-radius: 80px;
      border-top: 2px dashed #BFBFBF;
      border-left: 2px dashed #BFBFBF;
      border-bottom: 2px dashed #BFBFBF;
      position: relative;
      top: -10px;
      background: #fff;
      padding-top: 130px;
      padding-left: 138px;
      .zb1{
        position: absolute;
        left: -4px;
        top: -2px;
        width: 68px;
        height: 3px;
        background: #fff;
        z-index: 3;
      }
      .zb2{
        position: absolute;
        right: -49px;
        top: -2px;
        width: 56px;
        height: 3px;
        background: #fff;
        z-index: 3;
      }

    }
    .innovateR{
      padding-top: 37px;
      padding-left: 67px;
      box-sizing: content-box;
      .innovateLImg{
        width: 519px;
        margin-top: 60px;
        margin-left: 67px;
      }
    }
  }
  .service-c5box{
    display: flex;
    position: relative;
    width: 1200px;
    margin: 0 auto;
    .jwL{
      width: 50%;
      height: 250px;
      border-top-right-radius: 80px;
      border-top: 2px dashed #BFBFBF;
      border-right: 2px dashed #BFBFBF;
      position: relative;
      z-index: 88;
      top: -14px;
      background: #fff;
      .zb1{
        position: absolute;
        left: -1px;
        top: -3px;
        width: 53px;
        height: 3px;
        background: #fff;
        z-index: 3;
      }
      .zb2{
        position: absolute;
        right: -66px;
        top: 1px;
        width: 118px;
        height: 3px;
        background: #fff;
        z-index: 3;
      }
      .ending{
        position: absolute;
        right: -16px;
        bottom: -16px;
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        background:rgba(220,6,22,.17);
        border-radius:50%;
        .endingN{
          width:13px;
          height:13px;
          background:rgba(220,6,22,1);
          border-radius:50%;
        }
      }
    }
  }
}
/* 技术能力 */
.technical-box{
  margin-top: 110px;
  width: 100%;
  height: 628px;
  background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/technologyBG.png") no-repeat;
  -webkit-background-size: 100% 100%;
  background-size: 100% 100%;
  box-sizing: content-box;
  padding-top: 100px;
  .technical-t1{
    text-align: center;
    font-size:40px;
    font-weight:800;
    color:rgba(255,255,255,1);
  }
  .technical-t2{
    text-align: center;
    margin-top: 16px;
    font-size:20px;
    color: #fff;
  }
  .technical-cont-box{
    margin-top: 150px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    .technical-cont{
      width: 250px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .technical-cont-t{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 140px;
        height: 140px;
        background:rgba(255,255,255,0.09);
        border:1px solid rgba(255,255,255,1);
        border-radius:50%;
        .technical-cont-tImg{
          width: 60px;
        }
      }
      .technical-cont-t1{
        margin-top: 44px;
        font-size:26px;
        font-weight:bold;
        color:rgba(255,255,255,1);
      }
      .technical-cont-t2{
        margin-top: 17px;
        font-size:16px;
        color:rgba(255,255,255,1);
      }
    }
    .technical-box-and{
      width: 32px;
      height: 32px;
      margin: 0 25px;
      position: relative;
      bottom: -60px;
    }
  }
}

/* 合作案例 */
.cooperation-box{
  margin-top: 100px;
  .cooperation-t1{
    text-align: center;
    font-size:40px;
    font-weight:800;
    color: #0A0A0A;
  }
  .cooperation-t2{
    text-align: center;
    margin-top: 16px;
    font-size:20px;
    color: #687789;
  }
  .cooperation-swiper{
    margin: 88px auto 0 auto;
    position: relative;
    width: 1200px;
    .cooperation-slide{
      width: 378px;
      cursor: pointer;
      .industry-box-icon{
        width: 378px;
      }
    }
    .cooperation-swiper-btnbox{
      position: absolute;
      right: -60px;
      bottom: 4px;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      .cooperation-swiper-btn{
        margin-top: 7px;
        cursor: pointer;
      }
    }
  }
}

/* 合作伙伴 */
.partner-box{
  margin-top: 70px;
  margin-bottom: 50px;
  .partner-t1{
    font-size:40px;
    font-weight:800;
    text-align: center;
    color: #0A0A0A;
  }
  .partner-t2{
    margin-top: 16px;
    font-size:20px;
    text-align: center;
    color: #687789;
  }
  .partner-swiper{
    width: 1200px;
    margin: 67px auto 0 auto;
    position: relative;
    .partne-slide{
      width:221px;
      height:68px;
      border:1px solid rgba(229,229,229,1);
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .partne-slide1{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/zhuoyue.png") center center no-repeat;

    }
    .partne-slide1:hover{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/zhuoyue-a.png") center center no-repeat;

    }
    .partne-slide2{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/tangchao.png") center center no-repeat;
      -webkit-background-size: 50%;
      background-size: 50%;
    }
    .partne-slide2:hover{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/tangchao-a.png") center center no-repeat;
      -webkit-background-size: 50%;
      background-size: 50%;
    }
    .partne-slide3{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/pufa.png") center center no-repeat;
    }
    .partne-slide3:hover{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/pufa-a.png") center center no-repeat;
    }
    .partne-slide4{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/qiqu.png") center center no-repeat;
    }
    .partne-slide4:hover{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/qiqu-a.png") center center no-repeat;
    }
    .partne-slide5{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/qiaowen.png") center center no-repeat;
    }
    .partne-slide5:hover{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/qiaowen-a.png") center center no-repeat;
    }
    .partne-slide6{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/uxsino.png") center center no-repeat;

    }
    .partne-slide6:hover{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/uxsino-a.png") center center no-repeat;

    }
    .partne-slide7{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/Starbucks.png") center center no-repeat;

    }
    .partne-slide7:hover{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/Starbucks-a.png") center center no-repeat;
    }
    .partne-slide8{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/hershey.png") center center no-repeat;
    }
    .partne-slide8:hover{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/hershey-a.png") center center no-repeat;
    }
    .partne-slide9{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/qichen-ash.png") center center no-repeat;
      -webkit-background-size: 150px auto;
      background-size: 150px auto;
    }
    .partne-slide10:hover{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/hit-off.png") center center no-repeat;
      -webkit-background-size: 43px auto ;
      background-size: 43px auto ;
    }
    .partne-slide10{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/hit-off-ash.png") center center no-repeat;
      -webkit-background-size: 43px auto ;
      background-size: 43px auto ;
    }
    .partne-slide11:hover{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/GrowingIO.png") center center no-repeat;
      -webkit-background-size: 150px auto ;
      background-size: 150px auto ;
    }
    .partne-slide11{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/GrowingIO-ash.png") center center no-repeat;
      -webkit-background-size: 150px auto ;
      background-size: 150px auto ;
    }
    .partne-slide9:hover{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/qichen.png") center center no-repeat;
      -webkit-background-size: 150px auto;
      background-size: 150px auto;
    }
    .partne-slide12:hover{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/ld.png") center center no-repeat;
      -webkit-background-size: 80px auto ;
      background-size: 80px auto ;
    }
    .partne-slide12{
      background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/ld-ash.png") center center no-repeat;
      -webkit-background-size: 80px auto ;
      background-size: 80px auto ;
    }
    .art-prev{
      position: absolute;
      top: 25px;
      left: -35px;
      cursor: pointer;
    }
    .art-next{
      position: absolute;
      top: 25px;
      right: -35px;
      cursor: pointer;
    }
  }
}

.jump-box{
  width: 1px;
  height: 344px;
  background: #DCDCDC;
  position: fixed;
  top: 50%;
  margin-top: -172px;
  right: 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  transition: all .3s linear;
  .jump{
    cursor: pointer;
    position: relative;
    z-index: 999;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    background:rgba(220,6,22,0);
    border-radius:50%;
    .jumpN{
      width:13px;
      height:13px;
      /*background:rgba(220,6,22,1);*/
      background: #D2D2D2;
      border-radius:50%;
    }
    .jumpNTips{
      position: absolute;
      width: auto;
      left: -60px;
      padding: 4px 10px;
      background: #fff;
      -webkit-border-radius: 10px;
      -moz-border-radius: 10px;
      border-radius: 10px;
      color: #000;
      font-size: 15px;
      display: none;
    }
  }
  .jump:hover{
    background:rgba(220,6,22,.17);
  }
  .jump:hover .jumpN{
    background:rgba(220,6,22,1);
  }
  .jump:hover .jumpNTips{
    display: block;
  }
}

.logo-boxbg{
  display: flex;
  flex-wrap: wrap;
  width: 1600px;
  margin: 0px auto 0 auto;
  padding: 0 40px;
  .logo-box{
    width: 20%;
    height: 90px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    .logo-boxImgBG{
      display: flex;
      align-items: center;
    }
    .logo-boxImg{
      width: 150px;
      height: auto !important;
    }
  }
}


.scrmCont{
  width: 100%;
  display: flex;
  justify-content: center;
}
.scrmImg{
  width: 560px;
}
.scrmTextBox{
  width: 470px;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}
.scrmTitle{
  font-size: 24px;
  color: #fff;
  font-weight: bold;
}
.scrmText{
  font-size: 18px;
  color: #fff;
  display: flex;
  justify-content: flex-start;
}
.mt10{
  margin-top: 10px;
}
.mt38{
  margin-top: 38px;
}
.scrmContBG1{
  width: 100vw;
  display: flex;
  justify-content: center;
  padding: 55px 0;
}
.pl180{
  padding-left: 60px;
}
.pl70{
  padding-left: 70px;
}
.scrmContBG2{
  width: 100vw;
  display: flex;
  justify-content: center;
  padding: 55px 0;
}
</style>
